import { memo } from 'react';
import type { VFC } from 'react';

import type { Thing, WithContext } from 'schema-dts';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { getTVEpisodeStructuredData } from '../../shared/helpers/getStructuredData';
import { useAssetStructuredData } from '../utils/useAssetStructuredData';
import { isTVShowEpisode } from '../../shared/helpers/assetHelpers';

import { StructuredData } from './StructuredData';

type Props = {
  asset: SvpAssetAdditional;
};

const AssetPageStructuredDataBase: VFC<Props> = ({ asset }) => {
  const assetData = useAssetStructuredData(asset);

  const data: (WithContext<Thing> | undefined)[] = [assetData];
  if (asset && isTVShowEpisode(asset)) {
    data.push(getTVEpisodeStructuredData(asset));
  }

  return <StructuredData>{data}</StructuredData>;
};

export const AssetPageStructuredData = memo(AssetPageStructuredDataBase);
